// extracted by mini-css-extract-plugin
export var headerCell = "_1q-1";
export var loadingSpinnerContainer = "_1q-4";
export var loadingStateCell = "_1q-5";
export var rowWrapper = "_1q-3";
export var standaloneTable = "_1q-6";
export var table = "_1q-0";
export var white = "_1q-2";